import { render, staticRenderFns } from "./RsaGestioneCamereListComponent.vue?vue&type=template&id=8c904630"
import script from "./RsaGestioneCamereListComponent.vue?vue&type=script&lang=js"
export * from "./RsaGestioneCamereListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports